<div class="row">
  <h4 class="col-12">مجله افرا</h4>
  <div class="col-12 p-0 d-md-none">
    <swiper-container [navigation]="true" [loop]="true">
      <swiper-slide *ngFor="let item of newsItems">
        <div class="m-5">
          <ng-container
            *ngTemplateOutlet="magazineCard; context: { $implicit: item }"
          ></ng-container>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
  <div class="col-12 d-none d-md-block">
    <div class="row">
      <div class="col-6 col-lg-3 p-2" *ngFor="let item of newsItems">
        <ng-container
          *ngTemplateOutlet="magazineCard; context: { $implicit: item }"
        ></ng-container>
      </div>
    </div>
  </div>
  <button class="btn btn-outline-success w-auto mt-3 mx-auto">
    <a
      class="text-decoration-none text-reset"
      href="https://afraway.org/blog/"
      target="_blank"
    >
      {{ "homePage.labels.seeAll" | translate }}
    </a>
  </button>
  <ng-template #magazineCard let-item>
    <div
      class="bg-white bg-opacity-50 p-3 rounded d-flex flex-column"
      style="height: 280px"
    >
      <img
        [src]="item.image"
        class="card-img-top rounded object-fit-cover"
        alt="..."
        height="150px"
      />
      <div class="card-body d-flex flex-column flex-grow-1 h-0">
        <div class="mt-2 flex-grow-1 h-0 w-100 text-elipsis d-inline-block">
          <a
            [href]="item.link"
            class="text-decoration-none text-reset"
            target="_blank"
          >
            <p class="threeline-ellipsis">{{ item.title }}</p>
          </a>
        </div>
        <div>
          <ng-icon name="lucideCalendar" class="me-2 text-secondary"></ng-icon>
          <span class="text-secondary">{{ item.publish_time }}</span>
        </div>
      </div>
    </div>
  </ng-template>
</div>
